import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { MagnifyingGlassIcon } from "@components/icons";
import { Autocomplete } from "@components/inputs/Autocomplete/Autocomplete";
import { usePOAStore } from "@store/poaStore/poaStore";
import { usePOARikServiceProviderQuery } from "@services/powersOfAttorney/queries";
import { POAServiceProviderSource } from "../types";

interface IPowerOfAttorneyHouseAccordionSearchProps {
  jointBillServiceId: number;
}

export const PowerOfAttorneyHouseAccordionSearch: React.FC<
  IPowerOfAttorneyHouseAccordionSearchProps
> = (props) => {
  const { jointBillServiceId } = props;
  const { t } = useTranslation();
  const { addProvider } = usePOAStore();
  const [searchString, setSearchString] = useState("");
  const { data: rikServiceProviders } = usePOARikServiceProviderQuery({
    serviceProviderSearchWord: searchString,
  });

  const autocompleteData = useMemo(
    () =>
      rikServiceProviders?.serviceProviders.map((provider) => ({
        label: provider.serviceProviderName,
        value: provider.companyCode,
      })),
    [rikServiceProviders],
  );

  const onAutocompleteChange = (value: string) => {
    const rikServiceProvider = rikServiceProviders?.serviceProviders.find(
      (provider) => provider.companyCode === value,
    );

    if (!rikServiceProvider) {
      return;
    }

    addProvider(jointBillServiceId, {
      id: `undefined_${rikServiceProvider.companyCode}`,
      serviceProviderName: rikServiceProvider.serviceProviderName,
      companyCode: rikServiceProvider.companyCode,
      selected: true,
      serviceProviderSource: POAServiceProviderSource.Manual,
    });
  };

  return (
    <Autocomplete
      onChange={(value) => {
        onAutocompleteChange(value as string);
      }}
      isPositionFixed
      icon={MagnifyingGlassIcon}
      options={autocompleteData ?? []}
      onQueryChange={setSearchString}
      placeholder={t("powerOfAttorney.houseAccordion.searchPlaceholder")}
    />
  );
};
